




































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import store, { PreAccountingStore } from "../services/PreAccountingStore";
import PreAccountingApi from "../services/PreAccountingApi";
import { PreAccAccGroupSplit, PreAccAccGroupSplitRow, PreAccStoreDoc } from "../models/PreAccEditing";
import DateInput from "@/components/DateInput.vue";
import LookupComboBox from "@/components/LookupComboBox.vue";
import PartnerSearch from "@/modules/partner/views/PartnerSearch.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import { t } from "@/plugins/i18n";

interface Data {
    store: PreAccountingStore;
    // KÉK: a cikkszám beviteli mezője (a store-ban az azonosító él)
    partsCodeInput: string;
    // KÉK: a cikk-kereső (remote LookupComboBox) találatai + a keresés késleltetője
    partsLookupItems: any[];
    // A gépelés nélküli (kezdő) lista: az első 50 cikk, egyszer töltve
    partsDefaultItems: any[];
    partsSearchTimer: number | null;
    // Költséghely-bontás (K2D b_acc_group gomb → w_popup_accgritem) — csak GENI-nél
    splitMenu: boolean;
    splitLoaded: boolean;
    split: PreAccAccGroupSplit;
    // A K2D felső gridjének kiválasztott sora; erre szűr az alsó grid
    selectedSplitItemId: number;
    // Az alsó grid munkapéldánya (a Mégsem így nem ír semmit) + a törölt sorok
    splitRows: PreAccAccGroupSplitRow[];
    deletedSplitIds: number[];
    splitTempId: number;
    isSavingSplit: boolean;
    // Bizonylat-kiválasztás közben a partner-watcher ne nullázza a most beírt mezőt
    isApplyingStoreDoc: boolean;
    storeInColumns: string[];
    storeInFields: string[];
    storeOutColumns: string[];
    storeOutFields: string[];
    // K2D w_popup_storein_out pb_ok YesNo-kérdés — app-stílusú megerősítő sáv,
    // a beválasztott bizonylat a válaszig itt vár
    storeDocConfirmVisible: boolean;
    pendingStoreDoc: { kind: string; doc: any } | null;
}

interface Methods {
    formatMoney(value: number): string;
    onPartsCodeChanged(): Promise<void>;
    onPartsSearch(text: string): void;
    loadDefaultParts(): Promise<void>;
    onPartsSelected(item: any): Promise<void>;
    onPartnerChange(partner: any): void;
    storeFieldText(value: number): string;
    resetStoreFields(): void;
    onStoreDocSelected(kind: string, doc: any): void;
    applyStoreDoc(kind: string, doc: any): void;
    confirmStoreDoc(): void;
    cancelStoreDoc(): void;
    loadSplit(): Promise<void>;
    selectSplitItem(itemId: number): void;
    itemSplitSum(itemId: number): number;
    addSplitRow(): void;
    removeSplitRow(row: PreAccAccGroupSplitRow): void;
    saveSplit(): Promise<void>;
}

interface Computed {
    isGeni: boolean;
    isStockValueDiff: boolean;
    kekHeadEditable: boolean;
    showExchangeRate: boolean;
    storeDocConfirmMessage: string;
    splitMatches: boolean;
    splitReadOnly: boolean;
    visibleSplitRows: PreAccAccGroupSplitRow[];
    visibleSplitSum: number;
    splitTargetNetto: number;
    activeStoreKind: "storein" | "gstorein" | "storeout" | null;
    storeDocItems: any[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        DateInput,
        LookupComboBox,
        PartnerSearch,
        ConfirmationBox,
    },

    data() {
        return {
            store,
            partsCodeInput: store.head.partsCode ?? "",
            partsLookupItems: [] as any[],
            partsDefaultItems: [] as any[],
            partsSearchTimer: null as number | null,
            splitMenu: false,
            splitLoaded: false,
            split: { invoiceNetto: 0, sumNetto: 0, items: [], rows: [] } as PreAccAccGroupSplit,
            selectedSplitItemId: 0,
            splitRows: [] as PreAccAccGroupSplitRow[],
            deletedSplitIds: [] as number[],
            splitTempId: 0,
            isSavingSplit: false,
            isApplyingStoreDoc: false,
            storeInColumns: ["ID", "Partner", t("PreAccounting_Raktar"), t("Szallitolevel"), t("Datum"), t("Osszeg")],
            storeInFields: ["idText", "partnerName", "depotName", "delivInvNo", "docDate", "totalText"],
            storeOutColumns: ["ID", "Partner", t("InvoiceGroup_Atvevo"), t("Datum"), t("Osszeg")],
            storeOutFields: ["idText", "partnerName", "receiver", "docDate", "totalText"],
            storeDocConfirmVisible: false,
            pendingStoreDoc: null,
        };
    },

    computed: {
        storeDocConfirmMessage(): string {
            const doc = this.pendingStoreDoc?.doc;
            return doc
                ? t("PreAccounting_EzABetarolasMarSzerepelA", [doc.geniInvNo])
                : "";
        },

        // K2D: a bontás-gomb a szállítói számla sajátja
        isGeni() {
            return this.store.head.code === "GENI";
        },

        // K2D: a típus stock_value_diff flagje dönti el, hogy KÉK bizonylatról van szó
        isStockValueDiff() {
            return this.store.isStockValueDiff;
        },

        // K2D w_response_mix dw_master::retrieveend (:1083-1084): stock_value_diff > 1 és
        // acc_status ∉ {4,6} → ii_oper = 3, a fej is írható (típus, dátum, esemény,
        // megjegyzés, költséghely, cikk, periódus). Nem-KÉK MIX-en a fej zárolt marad.
        // A 4/6-os státusz és a tiltott főkönyvi szám kapuját a store.editable hordozza.
        kekHeadEditable() {
            return (
                this.store.head.isMix === true &&
                !this.store.isCreateMode &&
                this.store.isStockValueDiff &&
                !this.store.isReadOnlyView &&
                this.store.editable
            );
        },

        // K2D d_f_mixhead exchange_rate: visible="1~tif(storeout = 1, 1, 0)" — kitárolás
        // nélküli (storeout = 1 = nincs bizonylat) MIX-en jelenik meg az árfolyam
        showExchangeRate() {
            return this.store.head.isMix && this.store.head.storeOut === 1;
        },

        // A bontás a K2D-ben a bejövő számla rögzítőjéhez tartozik, ezért megtekintési
        // módban itt sem írható
        splitReadOnly() {
            return this.store.isReadOnlyView;
        },

        // K2D dw_acc_group szűrése a felső grid kiválasztott tételére. Tétel nélküli
        // számlánál a felső grid rejtve van, a rowfocuschanged sosem fut, így a K2D
        // szűrés nélkül MINDEN bontás-sort mutat (a régi, inv_item = 1 sorokat is) — a
        // backend ue_check-je is az összes sorra összegez, a kettőnek egyeznie kell
        visibleSplitRows() {
            if (this.split.items.length === 0) return this.splitRows;
            return this.splitRows.filter((x) => x.invItem === this.selectedSplitItemId);
        },

        visibleSplitSum() {
            return this.visibleSplitRows.reduce((sum, x) => sum + (Number(x.netto) || 0), 0);
        },

        // K2D ue_check viszonyítási alapja: a kiválasztott tétel nettója, tétel nélküli
        // számlánál (dw_1 rejtve) a számla nettója
        splitTargetNetto() {
            if (this.split.items.length === 0) return this.split.invoiceNetto;
            const item = this.split.items.find((x) => x.id === this.selectedSplitItemId);
            return item ? item.netto : 0;
        },

        // K2D ue_check: a bontás összegének egyeznie kell a viszonyítási összeggel
        splitMatches() {
            return this.visibleSplitSum === this.splitTargetNetto;
        },

        // A Típus flagjei szerinti aktív mozgásfajta (a store számolja a K2D-kapuk szerint)
        activeStoreKind() {
            return this.store.activeStoreKind;
        },

        // A választó-lista sorai a LookupComboBox megjelenítéséhez előkészítve
        storeDocItems() {
            return this.store.storeDocs.map((d: PreAccStoreDoc) => ({
                ...d,
                idText: String(d.id),
                // A total a forintos készlet-összeg (K2D lde_total) — a deviza a currTotal-é
                totalText: this.formatMoney(d.total),
            }));
        },
    },

    methods: {
        // K2D itemchanged 'mxstrparts_code': a beírt cikkszámot feloldjuk, és csak élő
        // cikkre engedjük — hibás kódnál a mező visszaáll ("Nincs ilyen élő cikk")
        async onPartsCodeChanged() {
            const code = (this.partsCodeInput ?? "").trim();
            if (!code) {
                this.store.head.parts = 1;
                this.store.head.partsCode = "";
                this.store.head.partsName = "";
                return;
            }
            try {
                const part = await PreAccountingApi.validatePart(code);
                this.store.head.parts = part.id;
                this.store.head.partsCode = code.toUpperCase();
                this.store.head.partsName = part.name;
                this.partsCodeInput = code.toUpperCase();
            } catch {
                // a globális hibakezelő már kiírta az üzenetet — visszaállunk
                this.partsCodeInput = this.store.head.partsCode ?? "";
            }
        },

        // K2D w_popup_parts_os: a cikk-kereső listája szerveroldalon szűr (a cikktörzs ~250 ezer
        // sor) — 300 ms késleltetéssel, legalább 3 karakterre szűr, az első 50 találat.
        // 3 karakter alatt (és gépelés nélkül, lenyitáskor) a lista első 50 eleme látszik.
        onPartsSearch(text: string) {
            if (this.partsSearchTimer) window.clearTimeout(this.partsSearchTimer);
            const q = (text ?? "").trim();
            if (q.length < 3) {
                this.loadDefaultParts();
                return;
            }
            this.partsSearchTimer = window.setTimeout(async () => {
                try {
                    const rows = await PreAccountingApi.searchParts(q);
                    this.partsLookupItems = rows.map((r) => ({ id: r.id, code: r.code, name: r.name }));
                } catch {
                    this.partsLookupItems = [];
                }
            }, 300);
        },

        // A kezdő lista (üres keresőszó) egyszer töltődik be, utána a memóriából jön
        async loadDefaultParts() {
            if (this.partsDefaultItems.length > 0) {
                this.partsLookupItems = this.partsDefaultItems;
                return;
            }
            try {
                const rows = await PreAccountingApi.searchParts("");
                this.partsDefaultItems = rows.map((r) => ({ id: r.id, code: r.code, name: r.name }));
                this.partsLookupItems = this.partsDefaultItems;
            } catch {
                this.partsLookupItems = [];
            }
        },

        // A LookupComboBox kétféle objektumot adhat: listából választott sort (id-vel), vagy
        // Enter-re a beírt szövegből képzett csonkot (csak a code mező). Az utóbbit — a K2D
        // itemchanged 'mxstrparts_code' mintájára — a validate/part úton oldjuk fel.
        async onPartsSelected(item: any) {
            const picked = item && typeof item === "object" ? item : null;
            if (picked && Number(picked.id) > 1) {
                this.store.head.parts = Number(picked.id);
                this.store.head.partsCode = String(picked.code ?? "").toUpperCase();
                this.store.head.partsName = picked.name ?? "";
                this.partsCodeInput = this.store.head.partsCode;
                return;
            }
            const typed = String(picked ? picked.code ?? "" : item ?? "").trim();
            this.partsCodeInput = typed === "-" ? "" : typed;
            await this.onPartsCodeChanged();
        },

        formatMoney(value: number): string {
            return new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(value ?? 0);
        },

        onPartnerChange(partner: any) {
            this.store.head.partner = partner.id;
            this.store.head.partnerName = partner.name;
        },

        // A tároló-mező kijelzett szövege: 1 = nincs kiválasztás (K2D '-' szemantika)
        storeFieldText(value: number): string {
            return value > 1 ? String(value) : "-";
        },

        // K2D itemchanged/b_partner: típus- vagy partner-váltáskor a tároló-mezők visszaállnak
        resetStoreFields() {
            this.store.head.storeIn = 1;
            this.store.head.gStoreIn = 1;
            this.store.head.storeOut = 1;
        },

        // K2D w_popup_storein_out pb_ok + w_response_mix buttonclicked: a kiválasztott
        // bizonylat tölti az összeget, devizát és partnert. Ha a bizonylat már szerepel
        // egy bejövő számlán, a döntésig várunk (app-stílusú sárga sáv, nem böngésző-confirm).
        onStoreDocSelected(kind: string, doc: any) {
            if (!doc || typeof doc !== "object" || !doc.id) return;
            if ((kind === "storein" || kind === "gstorein") && doc.geniInvNo > 1) {
                this.pendingStoreDoc = { kind, doc };
                this.storeDocConfirmVisible = true;
                return;
            }
            this.applyStoreDoc(kind, doc);
        },

        applyStoreDoc(kind: string, doc: any) {
            const head = this.store.head;
            this.isApplyingStoreDoc = true;
            head.storeIn = kind === "storein" ? doc.id : 1;
            head.gStoreIn = kind === "gstorein" ? doc.id : 1;
            head.storeOut = kind === "storeout" ? doc.id : 1;
            head.total = doc.total ?? 0;
            head.currTotal = doc.currTotal ?? 0;
            if (doc.invCurrency) head.invCurrency = doc.invCurrency;
            head.partner = doc.partnerId;
            head.partnerName = doc.partnerName;
            this.$nextTick(() => {
                this.isApplyingStoreDoc = false;
            });
        },

        confirmStoreDoc() {
            this.storeDocConfirmVisible = false;
            if (this.pendingStoreDoc) {
                this.applyStoreDoc(this.pendingStoreDoc.kind, this.pendingStoreDoc.doc);
                this.pendingStoreDoc = null;
            }
        },

        cancelStoreDoc() {
            this.storeDocConfirmVisible = false;
            this.pendingStoreDoc = null;
        },

        // A bontás a menü nyitásakor töltődik (számlánként újra). A sorokból munkapéldány
        // készül, hogy a Mégsem tényleg ne írjon semmit.
        async loadSplit() {
            const head = this.store.head;
            if (!head.invNo) return;
            try {
                this.split = await PreAccountingApi.getAccGroupSplit(head.code, head.invNo);
            } catch {
                this.split = { invoiceNetto: 0, sumNetto: 0, items: [], rows: [] };
            } finally {
                this.splitLoaded = true;
            }
            this.splitRows = JSON.parse(JSON.stringify(this.split.rows ?? []));
            this.deletedSplitIds = [];
            this.splitTempId = 0;
            // K2D dw_1::rowfocuschanged: induláskor az első tétel van kiválasztva
            this.selectedSplitItemId = this.split.items.length > 0 ? this.split.items[0].id : 0;
        },

        selectSplitItem(itemId: number) {
            this.selectedSplitItemId = itemId;
        },

        itemSplitSum(itemId: number): number {
            return this.splitRows
                .filter((x) => x.invItem === itemId)
                .reduce((sum, x) => sum + (Number(x.netto) || 0), 0);
        },

        // K2D cb_insert: új bontás-sor a kiválasztott tételre; tétel nélküli számlánál
        // (dw_1 rejtve) inv_item = 1
        addSplitRow() {
            if (this.splitReadOnly) return;
            this.splitTempId--;
            // K2D: a még szétdobható összeg — pozitív tételnél max(0, …), negatívnál min(0, …)
            const remaining = this.splitTargetNetto - this.visibleSplitSum;
            const netto = this.splitTargetNetto >= 0 ? Math.max(0, remaining) : Math.min(0, remaining);
            this.splitRows.push({
                id: this.splitTempId,
                invItem: this.split.items.length > 0 ? this.selectedSplitItemId : 1,
                invItemName: "",
                accGroup: this.store.accGroups.length > 0 ? this.store.accGroups[0].id : 1,
                accGroupName: "",
                netto,
                dimCode2: "",
            });
        },

        // K2D cb_delete: a sor törlése (a mentés viszi ki az adatbázisból)
        removeSplitRow(row: PreAccAccGroupSplitRow) {
            if (this.splitReadOnly) return;
            this.splitRows = this.splitRows.filter((x) => x !== row);
            if (row.id > 0) this.deletedSplitIds.push(row.id);
        },

        // K2D pb_ok: ue_check → update → commit; utána a hívó felajánlja az újrakontírozást
        async saveSplit() {
            if (this.splitReadOnly || !this.splitMatches) return;
            const head = this.store.head;
            this.isSavingSplit = true;
            try {
                this.split = await PreAccountingApi.saveAccGroupSplit(head.code, head.invNo, {
                    rows: this.splitRows.map((x) => ({
                        id: x.id > 0 ? x.id : 0,
                        // K2D cb_insert: tétel nélküli számlánál inv_item = 1 kerül az adatbázisba
                        // (biztonsági háló, ha valahol 0 maradt volna)
                        invItem: x.invItem || 1,
                        invItemName: "",
                        accGroup: x.accGroup,
                        accGroupName: "",
                        netto: Number(x.netto) || 0,
                        dimCode2: x.dimCode2 ?? "",
                    })),
                    deletedIds: [...this.deletedSplitIds],
                });
                this.splitRows = JSON.parse(JSON.stringify(this.split.rows ?? []));
                this.deletedSplitIds = [];
                this.splitTempId = 0;
                this.splitMenu = false;
                // K2D: „Változtatott a számla költséghely bontásán… Újra akarja most
                // kontíroztatni?" — a kérdést a szerkesztő teszi fel
                this.$emit("accGroupSplitSaved");
            } catch {
                // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
            } finally {
                this.isSavingSplit = false;
            }
        },
    },

    watch: {
        // Számlaváltás/újratöltés után a cikkszám-mező a friss fejből induljon
        "store.head.partsCode": function (value: string) {
            this.partsCodeInput = value ?? "";
        },

        // Lapozásnál/számlaváltásnál ne a korábbi számla bontása maradjon a menüben
        "store.head.invNo"() {
            this.split = { invoiceNetto: 0, sumNetto: 0, items: [], rows: [] };
            this.splitLoaded = false;
            this.splitMenu = false;
        },

        // K2D dw_master itemchanged (inv_type): típus-váltáskor a tároló-mezők visszaállnak,
        // és az új típushoz tartozó lista töltődik
        "store.head.invType"() {
            if (!this.store.isCreateMode) return;
            this.resetStoreFields();
            this.store.loadStoreDocs();
        },

        // K2D b_partner: partner-váltás is nullázza a kiválasztást (a betárolás-listák
        // partnerre szűrtek) — kivéve, ha épp a bizonylat-kiválasztás írta át a partnert
        "store.head.partner"() {
            if (!this.store.isCreateMode || this.isApplyingStoreDoc) return;
            this.resetStoreFields();
            this.store.loadStoreDocs();
        },
    },
});
